export default "__VITE_ASSET__DQLbD4y3__"